/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TitleLarge from 'DesignSystem/TitleLarge/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/Person/Content"
  
}) {
let personFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'first_name',
})
  return (<React.Fragment
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 level="h1"
 data="person.first_name"
 text={personFirstNameValueData}
 marginLeft={6}
 lineHeight={1}
/>
{children}
</React.Fragment>)
}